import { gql } from "@apollo/client";

export const GET_DOMAIN_CONFIGURATION = gql`
  query GetDomainConfig($domain: String!) {
    domainConfiguration(domain: $domain) {
      page {
        title
        subtitle
        background
        logo
        navbarConfig {
          logo
          title
        }
      }
      customPage
      header {
        title
        shortcutIcon
        icon16
        icon32
        appleTouchIcon
      }
    }
  }
`;
